import React from "react";

function RollCompactorMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Roll Compactor Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Roll Compactor Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/17.png"
                        alt="Roll Compactor Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Roll Compactor Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Roll Compactor Machine is designed for dry granulation
                      of powders without using heat or moisture. It ensures
                      uniform densification using high-pressure rollers,
                      producing strong granules ideal for tablet compression.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Featuring a heavy-duty design, precise hydraulic pressure
                      control, feed screw mechanism, and stainless-steel contact
                      parts, this machine delivers consistent ribbon formation,
                      with low fines and high throughput.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/17.png"
                            alt="Roll Compactor Image"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/18.png"
                            alt="Roll Compactor Image"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-RC-200</td>
                          <td>DPM-RC-300</td>
                          <td>DPM-RC-450</td>
                        </tr>

                        <tr>
                          <td>Roller Diameter</td>
                          <td>200 mm</td>
                          <td>300 mm</td>
                          <td>450 mm</td>
                        </tr>

                        <tr>
                          <td>Roller Width</td>
                          <td>75 mm</td>
                          <td>100 mm</td>
                          <td>150 mm</td>
                        </tr>

                        <tr>
                          <td>Production Capacity</td>
                          <td>50–80 kg/hr</td>
                          <td>150–300 kg/hr</td>
                          <td>350–600 kg/hr</td>
                        </tr>

                        <tr>
                          <td>Feeding Motor</td>
                          <td>1 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>5 HP</td>
                          <td>7.5 HP</td>
                          <td>10 HP</td>
                        </tr>

                        <tr>
                          <td>Hydraulic Motor</td>
                          <td>1 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                        <tr>
                          <td>Working Pressure</td>
                          <td>0–4 Tons</td>
                          <td>0–8 Tons</td>
                          <td>0–12 Tons</td>
                        </tr>

                        <tr>
                          <td>Overall Dimensions (L × W × H)</td>
                          <td>1200 × 900 × 1700 mm</td>
                          <td>1500 × 1100 × 1850 mm</td>
                          <td>1800 × 1300 × 2000 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>650 kg</td>
                          <td>950 kg</td>
                          <td>1300 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/rapid-mixer-granulator">
                          Rapid Mixer Granulator (RMG)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default RollCompactorMachine;
